export default __webpack_public_path__ + "static/media/oldeuro.f5d2afdb.svg";